import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { FuseqHeaders } from '../../FuseQ/fuseq.headers'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
@Injectable({
  providedIn: 'root'
})
export class DashboardApiService {
  constructor (private readonly http: HttpClient, private readonly fuseqHeaders: FuseqHeaders) { }
  // DASHBOARD
  allStats (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/dashboard/allStats`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  countISEUsers (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/dashboard/countISEUsers`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  countISEGroups (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/dashboard/countISEGroups`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  countISEEndpoints (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/dashboard/countISEEndpoints`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  countAdminAlias (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/dashboard/countAdminAlias`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getRowDetails (type, id): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/dashboard/rowDetails?type=${type}&id=${id}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  // DASHBOARD LIST
  listISEUsers (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/ise/listISEUsers`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  listISEGroups (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/ise/listISEGroups`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  listISEEndpoints (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/ise/listISEEndpoints`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  listISENode (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/ise/listISENode`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  listISEDevice (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/ise/listISEDevice`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  listISESgt (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/ise/listISESgt`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  listISENetworkdevicegroup (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/ise/listISENetworkdevicegroup`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  listISESgmapping (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/ise/listISESgmapping`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  listISESgmappinggroup (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/ise/listISESgmappinggroup`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  listISEEndpointgroup (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/ise/listISEEndpointgroup`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  listISEAdminuser (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/ise/listISEAdminuser`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  listRPWAdmins (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/administratorconfigurations`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  listRPWAlias (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/aliasconfigurations`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getUsers (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/user/list`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getUserStats (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/user/getuserstats`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  addUser (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/user/add`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  deleteUser (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/user/remove`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  modifyUser (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/user/edit`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  getgroups (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/group/list`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  addgroup (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/group/add`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  deletegroup (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/group/remove`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  modifygroup (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/group/edit`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  getroles (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/role/list`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  addrole (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/role/add`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  deleterole (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/role/remove`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  modifyrole (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/role/edit`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  getpermissions (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/permission/list`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getPermissionsinheritedList (idUser): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/permission/inheritedlist/${idUser}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  addpermission (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/permission/add`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  deletepermission (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/permission/remove`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  modifypermission (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/permission/edit`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  groupuser (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/mapp/grp_usr`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  roleuser (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/mapp/role_usr`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  permuser (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/mapp/prm_usr`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  grpperm (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/mapp/grp_prm`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  roleperm (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/mapp/role_prm`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  dlt_grp_prm (id): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/mapp/dlt_grp_prm`
    return this.http.post(APIEndPoint, id, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  dlt_role_prm (id): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/mapp/dlt_role_prm`
    return this.http.post(APIEndPoint, id, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  dlt_grp_usr (id): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/mapp/dlt_grp_usr`
    return this.http.post(APIEndPoint, id, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  dlt_role_usr (id): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/mapp/dlt_role_usr`
    return this.http.post(APIEndPoint, id, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  dlt_prm_usr (id): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/mapp/dlt_prm_usr`
    return this.http.post(APIEndPoint, id, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  sel_grp_prm (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/mapp/sel_grp_prm`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  sel_role_prm (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/mapp/sel_role_prm`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  sel_grp_usr (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/mapp/sel_grp_usr`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  sel_role_usr (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/mapp/sel_role_usr`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  sel_prm_usr (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/mapp/sel_prm_usr`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getRemoteCsvHeaders (Path: string): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/raker/getRemoteCSV?remote=${Path}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getRemoteJsonColumns (Path: string): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/raker/getRemoteJsonColumns?Path=${Path}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getRespApiColumns (Payload): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/raker/getRespApiColumns`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  getSoapColumns (Path): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/raker/getSoapColumns?Path=${Path}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getRakerList (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/rakerManager/getRakerList`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getDatabaseColumnsByQuery (Payload): Observable<any> {
    const APIEndPoint = `${environment.API_URL_RAKER}/rakerEngine/testQuery`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  testDbConnection (Payload): Observable<any> {
    const APIEndPoint = `${environment.API_URL_RAKER}/rakerEngine/testConnection`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  rakerCreate (Payload): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/rakerManager/rakerCreate`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  rakerDelete (Payload): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/rakerManager/delete`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  rakerEdit (Payload): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/rakerManager/rakerEdit`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  scheduleCreate (Payload): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/rakerManager/scheduleCreate`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  scheduleDelete (ScheduleID: number): Observable<any> {
    const Payload = { Id: ScheduleID }
    const APIEndPoint = `${environment.API_URL}/rakerManager/scheduleDelete`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  scheduleEdit (Payload): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/rakerManager/schedueEdit`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  scheduleList (Payload) {
    const APIEndPoint = `${environment.API_URL}/rakerManager/scheduleList`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  getJobByScheduleId (ScheduleID: number) {
    const Payload = { IdSchedule: ScheduleID }
    const APIEndPoint = `${environment.API_URL}/rakerManager/jobList`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  getDashboardsList () {
    const APIEndPoint = `${environment.API_URL}/dashboard/getDashboardsList`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getWidgetsByDashId (id) {
    const APIEndPoint = `${environment.API_URL}/dashboard/getWidgetsByDashId?DashboardId=${id}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  AddWidgetsByDashId (obj) {
    const Payload = { Obj: obj }
    const APIEndPoint = `${environment.API_URL}/dashboard/AddWidgetsByDashId`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  editWidgetsByDashId (id, obj) {
    const Payload = { Id: id, Obj: obj }
    const APIEndPoint = `${environment.API_URL}/dashboard/editWidgetsByDashId`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  deleteDashboard (id) {
    const Payload = { Id: id }
    const APIEndPoint = `${environment.API_URL}/dashboard/deleteDashboard`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  deleteWidgetsByDashId (id) {
    const Payload = { Id: id }
    const APIEndPoint = `${environment.API_URL}/dashboard/deleteWidgetsByDashId`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  addDashboard (obj) {
    const Payload = { Obj: obj }
    const APIEndPoint = `${environment.API_URL}/dashboard/addDashboard`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  editDashboard (id, obj) {
    const Payload = { Id: id, Obj: obj }
    const APIEndPoint = `${environment.API_URL}/dashboard/editDashboard`
    return this.http.post(APIEndPoint, Payload, this.fuseqHeaders.setTokenHeaders('POST'))
  }
}
